export default __webpack_public_path__ + "static/Group-148807-9f466054d226f1e9255858a553c39126.png";